import { PaymentRules, Game, PaymentType } from "../types/game";
import { isRangeGame } from "./rhiGame";

export type PaymentCollectionMethod = "stripe" | "manual" | "both";

/** Missing type defaults to per-player (legacy games saved without paymentRules.type). */
export function resolvePaymentType(rules?: PaymentRules): PaymentType {
  return rules?.type === PaymentType.TEAM ? PaymentType.TEAM : PaymentType.MULTIPLE_PLAYER;
}

export function calculateEntryFeeTotal(rules: PaymentRules | undefined, playersCount: number): number {
  const normalized = defaultPaymentRulesForPaidGame(rules);
  if (resolvePaymentType(rules) === PaymentType.MULTIPLE_PLAYER) {
    return normalized.fee * playersCount;
  }
  return normalized.fee * Math.ceil(playersCount / 4);
}

export function normalizeCollectionMethod(rules?: PaymentRules): PaymentCollectionMethod {
  const m = rules?.collectionMethod;
  if (m === "stripe" || m === "both") return "stripe";
  if (m === "manual") return "stripe";
  return "stripe";
}

export function allowsStripeCheckout(_rules?: PaymentRules): boolean {
  return true;
}

export function allowsManualCollection(_rules?: PaymentRules, game?: Pick<Game, "isRangeGame">): boolean {
  if (isRangeGame(game)) return false;
  return true;
}

function normalizeFee(fee: unknown): number {
  return typeof fee === "number" && Number.isFinite(fee) && fee >= 0 ? fee : 0;
}

export function defaultPaymentRulesForPaidGame(existing?: PaymentRules): PaymentRules {
  return {
    type: existing?.type ?? 1,
    fee: normalizeFee(existing?.fee),
    payBeforePlay: existing?.payBeforePlay ?? false,
    collectionMethod: "stripe",
  };
}

export function normalizeCollectionForPayBeforePlay(rules: PaymentRules): PaymentRules {
  return { ...rules, collectionMethod: "stripe" };
}
